(function () {
  'use strict';

  if (window.__oeExBereit) return;
  window.__oeExBereit = true;

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  try {
    var bw = new URLSearchParams(location.search).get('bewegung');
    if (bw === 'an' || bw === 'aus') sessionStorage.setItem('3idee_bewegung', bw);
    if (sessionStorage.getItem('3idee_bewegung') === 'an') ruhig = false;
  } catch (e) {}

  var ST = { 'stange': { u: .5, v: .579, w: .584 }, 'verbinder-r': { u: .558, v: .117, w: .138 },
    'arm-r1': { u: .649, v: .117, w: .2125 }, 'arm-r2': { u: .776, v: .117, w: .2125 },
    'platte-r': { u: .883, v: -.01, w: .181 } };
  var EX = { 'stange': [0, 0], 'verbinder-r': [55, -30], 'arm-r1': [95, -110], 'arm-r2': [150, -200], 'platte-r': [250, -200] };
  var EXH = { 'stange': [0, 0], 'verbinder-r': [25, -60], 'arm-r1': [40, -170], 'arm-r2': [65, -290], 'platte-r': [165, -290] };
  var HUB = { x: 215, xh: 305 }, KOPF = { x: 60, xh: 190 }, EXT = { x: EX, xh: EXH };
  var IN = { 'stange': [.409, .155, .591, .845], 'verbinder-r': [.301, .28, .699, .721], 'arm-r1': [.151, .407, .796, .672],
    'arm-r2': [.151, .407, .796, .672], 'platte-r': [.271, .295, .672, .718], 'fed': [.159, .075, .835, .674] };
  var T1 = { 'stange': { u: .5, v: .658, w: .49 }, 'verbinder-r': { u: .54, v: .468, w: .14 },
    'arm-r1': { u: .647, v: .409, w: .32 }, 'fed-r': { u: .829, v: .214, w: .27 },
    'platte-r': { u: .952, v: .084, w: .227 }, 'kopf': { u: .5, v: .296, w: .227 } };
  var BB = [32 / 1600, 43 / 862, 1568 / 1600, 819 / 862];
  var ZR = [128 / 1600, 458 / 1600, 1472 / 1600, 1228 / 1600];
  var NEUN = ['stange', 'verbinder-r', 'verbinder-l', 'arm-r1', 'arm-l1', 'arm-r2', 'arm-l2', 'platte-r', 'platte-l'];

  function kl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function cl(a, b, x) { return kl((x - a) / (b - a)); }
  function we(x) { return x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
  function eo(x) { return 1 - Math.pow(1 - x, 3); }
  function le(a, b, t) { return a + (b - a) * t; }
  function sp(k) { return k.replace(/-l(\d?)$/, '-r$1'); }
  function geo(k, T) {
    var r = sp(k), g = T[r];
    if (!g) return null;
    if (r === k) return g;
    return g.slice ? [-g[0], g[1]] : { u: 1 - g.u, v: g.v, w: g.w };
  }
  function zahlen(s) { return (s || '').split(',').map(parseFloat); }

  var buehnen = [];

  function einrichten(spur) {
    if (spur.hasAttribute('data-oe-ex-bereit')) return;
    var bu = spur.querySelector('.oe-h3__buehne');
    var raum = spur.querySelector('.oe-h3__raumbild');
    var vor = spur.querySelector('.oe-h3__halterung');
    var ex = spur.querySelector('[data-oe-ex]');
    var teileBox = ex && ex.querySelector('.oe-ex__teile');
    if (!bu || !raum || !vor || !ex || !teileBox) return;
    spur.setAttribute('data-oe-ex-bereit', '');
    spur.classList.add('oe-h3--lauf');
    if (ruhig) {
      spur.classList.add('oe-h3--ruhig');
      var rb = { ruhig: true, spur: spur, bu: bu, raum: raum, vor: vor, ex: ex, teileBox: teileBox,
        mons: Array.prototype.slice.call(spur.querySelectorAll('.oe-h3__monitor')),
        rahmen: zahlen(spur.getAttribute('data-oe-ex-rahmen')), lage: zahlen(spur.getAttribute('data-oe-ex-lage')), SB: null };
      ruhigBauen(rb);
      buehnen.push(rb);
      return;
    }

    var ebene = document.createElement('div');
    ebene.className = 'oe-ex-ebene';
    ebene.setAttribute('aria-hidden', 'true');
    ebene.appendChild(teileBox);
    document.body.appendChild(ebene);
    var leiste = spur.querySelector('[data-oe-leiste]');
    if (leiste) { leiste.classList.add('oe-h3-leiste--frei'); document.body.appendChild(leiste); }

    var teil = {};
    Array.prototype.forEach.call(teileBox.querySelectorAll('.oe-ex__teil'), function (el) {
      teil[el.getAttribute('data-teil')] = el;
      var img = el.querySelector('img');
      if (img) img.loading = 'eager';
    });
    var name = {};
    Array.prototype.forEach.call(teileBox.querySelectorAll('[data-name]'), function (el) {
      name[el.getAttribute('data-name')] = el;
    });

    var b = {
      spur: spur, bu: bu, raum: raum, vor: vor, ex: ex, ebene: ebene, leiste: leiste,
      akt1: spur.querySelector('.oe-h3__akt1'),
      mons: Array.prototype.slice.call(spur.querySelectorAll('.oe-h3__monitor')),
      kopfText: ex.querySelector('.oe-ex__kopf'),
      schritte: Array.prototype.slice.call(ex.querySelectorAll('.oe-ex__schritt')),
      rahmen: zahlen(spur.getAttribute('data-oe-ex-rahmen')),
      lage: zahlen(spur.getAttribute('data-oe-ex-lage')),
      neun: NEUN.map(function (k) { return { k: k, el: teil[k], s: geo(k, ST), x: geo(k, EX), xh: geo(k, EXH) }; }).filter(function (t) { return t.el; }),
      feds: [{ k: 'fed-r', el: teil['fed-r'], arm: 'arm-r2', sg: 1 }, { k: 'fed-l', el: teil['fed-l'], arm: 'arm-l2', sg: -1 }].filter(function (f) { return f.el; }),
      kopf: teil['kopf'], name: name, SB: null, ziel: null,
      liste: ex.querySelector('[data-oe-liste]'), zeile: {}
    };
    if (b.liste) Array.prototype.forEach.call(b.liste.querySelectorAll('[data-zeile]'), function (el) {
      b.zeile[el.getAttribute('data-zeile')] = el;
    });
    zielSuchen(b);
    buehnen.push(b);
  }

  var hM = (776 / 862 * (.8983 - .6202) * 1621) / (1536 / 1600 * (.8523 - .5734) * 3000) * 1045;
  function ruhigLagen(X) {
    var E = EXT[X], ga = ST['arm-r2'].w * 1045, gp = ST['platte-r'].w * 1045, L = { 1: [], 2: [], 3: [] };
    NEUN.forEach(function (k) {
      var s = geo(k, ST), x = geo(k, E), sg = k.indexOf('-l') > 0 ? -1 : 1;
      var t = { k: k, x: (s.u - .5) * 1045 + x[0], y: s.v * hM + x[1], g: s.w * 1045, i: IN[sp(k)] };
      L[1].push(t);
      var t2 = t;
      if (k === 'arm-r2' || k === 'arm-l2') t2 = { k: 'fed-' + (sg > 0 ? 'r' : 'l'), x: t.x, y: t.y, g: ga, i: IN.fed };
      else if (k.indexOf('platte') === 0) t2 = { k: k, x: t.x + sg * ga * 46 / 800, y: t.y - ga * 267 / 800, g: t.g, i: t.i };
      L[2].push(t2); L[3].push(t2);
    });
    L[3].push({ k: 'kopf', x: 0, y: -KOPF[X] - 80, g: gp, i: IN['platte-r'] });
    var r = 0, o = 1e9, u = -1e9;
    [1, 2, 3].forEach(function (n) {
      L[n].forEach(function (t) {
        var i = t.i, ab = t.k.indexOf('-l') > 0;
        var lx = t.x + ((ab ? 1 - i[2] : i[0]) - .5) * t.g, rx = t.x + ((ab ? 1 - i[0] : i[2]) - .5) * t.g;
        r = Math.max(r, Math.abs(lx), Math.abs(rx));
        o = Math.min(o, t.y + (i[1] - .5) * t.g); u = Math.max(u, t.y + (i[3] - .5) * t.g);
      });
    });
    return { L: L, r: r + 8, o: o - 8, u: u + 8 };
  }
  function ruhigBild(rb, n, R) {
    var w = 2 * R.r, h = R.u - R.o;
    var feld = document.createElement('div');
    feld.className = 'oe-exr__bild';
    feld.style.aspectRatio = (w / h).toFixed(4);
    feld.setAttribute('aria-hidden', 'true');
    var vorlage = {};
    Array.prototype.forEach.call(rb.teileBox.querySelectorAll('.oe-ex__teil'), function (el) { vorlage[el.getAttribute('data-teil')] = el; });
    var pos = {};
    R.L[n].forEach(function (t) {
      var v = vorlage[t.k];
      if (!v) return;
      var el = v.cloneNode(true), st = el.style;
      st.left = ((t.x - t.g / 2 + R.r) / w * 100).toFixed(3) + '%';
      st.top = ((t.y - t.g / 2 - R.o) / h * 100).toFixed(3) + '%';
      st.width = (t.g / w * 100).toFixed(3) + '%';
      feld.appendChild(el);
      pos[t.k] = t;
    });
    var namen = n === 1 ? ['stange', 'verbinder-r', 'arm-r1', 'platte-r'] : n === 2 ? ['fed'] : ['kopf'];
    namen.forEach(function (k) {
      var v = rb.teileBox.querySelector('[data-name="' + k + '"]');
      if (!v) return;
      var x, y;
      if (k === 'fed') { var q = pos['fed-r']; x = q.x + q.g * .3; y = q.y - q.g * .38; }
      else if (k === 'kopf') { var kq = pos.kopf; x = kq.x; y = kq.y - kq.g * .25; }
      else { var p = pos[k]; x = p.x; y = p.y + (k === 'stange' ? p.g * .3 : k === 'verbinder-r' ? p.g * .2 : -p.g * .3); }
      var el = v.cloneNode(true);
      el.style.left = ((x + R.r) / w * 100).toFixed(3) + '%';
      el.style.top = ((y - R.o) / h * 100).toFixed(3) + '%';
      feld.appendChild(el);
    });
    return feld;
  }
  function ruhigBauen(rb) {
    var alt = rb.spur.querySelector('.oe-exr');
    if (alt) alt.parentNode.removeChild(alt);
    var schmal = (window.innerWidth || document.documentElement.clientWidth) < 750;
    rb.schmalR = schmal;
    var R = ruhigLagen(schmal ? 'xh' : 'x');
    var schritte = rb.ex.querySelectorAll('.oe-ex__schritt');
    var box = document.createElement('div');
    box.className = 'oe-exr';
    [1, 2, 3].forEach(function (n) {
      var s = schritte[n - 1];
      if (!s) return;
      var teil = document.createElement('div');
      teil.className = 'oe-exr__schritt';
      var kopf = document.createElement('div');
      kopf.className = 'oe-exr__kopf';
      kopf.innerHTML = s.innerHTML;
      teil.appendChild(kopf);
      teil.appendChild(ruhigBild(rb, n, R));
      var zeile = document.createElement('ul');
      zeile.className = 'oe-exr__liste';
      var welche = n === 1 ? ['stange', 'verbinder', 'arm', 'platte'] : n === 2 ? ['fed'] : ['kopf'];
      welche.forEach(function (k) {
        var li = rb.ex.querySelector('[data-oe-liste] [data-zeile="' + k + '"]');
        if (li) zeile.appendChild(li.cloneNode(true));
      });
      teil.appendChild(zeile);
      box.appendChild(teil);
    });
    if (schritte[3]) {
      var schluss = document.createElement('div');
      schluss.className = 'oe-exr__schluss';
      schluss.innerHTML = schritte[3].innerHTML;
      box.appendChild(schluss);
    }
    rb.spur.appendChild(box);
  }

  function zielSuchen(b) {
    b.ziel = null;
    var id = b.ex.getAttribute('data-oe-ex-ziel');
    if (!id) return;
    var karte = document.querySelector('[data-oe-set-liste] product-card[data-product-id="' + id + '"]');
    var box = karte && (karte.querySelector('.card-gallery .product-media-container') || karte.querySelector('.card-gallery'));
    if (!box) return;
    b.ziel = { box: box };
  }

  function lege(b) {
    var br = b.bu.getBoundingClientRect(), rb = b.raum.parentNode.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var nw = b.raum.naturalWidth || 3000, nh = b.raum.naturalHeight || 1621;
    var R = b.rahmen, V = b.lage, hoch = br.width / br.height < 0.8;
    var gerollt = (document.scrollingElement ? document.scrollingElement.scrollTop : 0) +
      (document.querySelector('.page-wrapper') ? document.querySelector('.page-wrapper').scrollTop : 0);
    var start = b.spur.getBoundingClientRect().top + gerollt;
    var verdeckt = Math.max(0, start + br.height - vh);
    var BW = rb.width, BH = rb.height, unten = Math.max(BH * .5, BH - verdeckt) * (1 - (hoch ? .06 : .08));
    var s = Math.max(BW / nw, BH / nh, (BH - unten) / (1 - R[3]) / nh), cw, ch, rx, ry;
    var schmal = br.width < 1024 || br.width / br.height < 1.1;
    b.spur.classList.toggle('oe-h3--schmal', schmal);
    if (schmal) {
      var gruppe = (472 * 2 + 613) / 1045 * (BB[2] - BB[0]) * (R[2] - R[0]);
      s = Math.min(s, .92 * BW / (nw * gruppe));
    }
    cw = nw * s; ch = nh * s;
    if (schmal) {
      rx = Math.min(0, Math.max(BW - cw, BW / 2 - (R[0] + R[2]) / 2 * cw));
      var titel = b.spur.querySelector('.oe-h3__titel');
      var oben0 = titel ? titel.getBoundingClientRect().bottom - rb.top + 32 : 0;
      var mmB = (BB[2] - BB[0]) * (R[2] - R[0]) * cw / 1045;
      var monO = (R[1] + BB[1] * (R[3] - R[1])) * ch - 132.5 * mmB, tischU = (R[3] + .03) * ch;
      var frei = unten - oben0 - (tischU - monO);
      ry = frei > 0 ? oben0 + frei * (BW < 600 ? .33 : .6) - monO : unten - R[3] * ch;
      ry = Math.min(ry, unten - R[3] * ch);
    } else {
      var opx = parseFloat((getComputedStyle(b.raum).objectPosition || '100% 50%').split(' ')[0]);
      rx = (BW - cw) * (isNaN(opx) ? 100 : opx) / 100;
      ry = Math.min(0, Math.max(BH - ch, unten - R[3] * ch));
    }
    var st = b.raum.style;
    st.width = cw + 'px'; st.height = ch + 'px'; st.left = rx + 'px'; st.top = ry + 'px';
    var ox = rb.left - br.left + rx, oy = rb.top - br.top + ry;
    var P = { l: ox + R[0] * cw, t: oy + R[1] * ch, w: (R[2] - R[0]) * cw, h: (R[3] - R[1]) * ch };
    b.SB = { l: P.l + BB[0] * P.w, t: P.t + BB[1] * P.h, w: (BB[2] - BB[0]) * P.w, h: (BB[3] - BB[1]) * P.h };
    b.vor.style.left = (ox + V[0] * cw) + 'px';
    b.vor.style.top = (oy + V[1] * ch) + 'px';
    b.vor.style.width = ((V[2] - V[0]) * cw) + 'px';
    var mm = b.SB.w / 1045, cx = b.SB.l + b.SB.w / 2, cy = b.SB.t + 50 * mm;
    b.mons.forEach(function (el, i) {
      var mw = 613 * mm, mh = 365 * mm, x = cx + (i ? 472 : -472) * mm;
      el.style.width = mw + 'px';
      el.style.height = mh + 'px';
      el.style.left = (x - mw / 2) + 'px';
      el.style.top = (cy - mh / 2) + 'px';
    });
  }

  function setz(el, x, y, g, o) {
    var st = el.style;
    st.width = g.toFixed(1) + 'px';
    st.height = g.toFixed(1) + 'px';
    st.transform = 'translate(' + (x - g / 2).toFixed(1) + 'px,' + (y - g / 2).toFixed(1) + 'px)';
    if (o != null) st.opacity = kl(o).toFixed(3);
  }

  function schild(el, x, y) {
    var vw = window.innerWidth || document.documentElement.clientWidth, h = el.offsetWidth / 2;
    var xt = h * 2 + 16 > vw ? vw / 2 : Math.min(Math.max(x, h + 8), vw - h - 8);
    el.style.setProperty('--oe-strich', (x - xt).toFixed(1) + 'px');
    el.style.transform = 'translate(' + xt.toFixed(1) + 'px,' + y.toFixed(1) + 'px) ' +
      (el.classList.contains('oe-ex__name--oben') ? 'translate(-50%,-100%)' : 'translate(-50%,0)');
  }

  function zeichne(b) {
    if (!b.SB) lege(b);
    if (b.ruhig) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var sr = b.spur.getBoundingClientRect(), br = b.bu.getBoundingClientRect();
    var haft = parseFloat(getComputedStyle(b.bu).top) || 0;
    var roh = kl((haft - sr.top) / Math.max(1, sr.height - br.height));
    var p = roh < .2 ? roh * .5 : .1 + (roh - .2) * .9 / .8;
    var W = br.width, H = br.height, hoch = W / H < 0.8, SB = b.SB;

    var t1 = cl(0, .1, p);
    if (b.akt1) {
      b.akt1.style.opacity = (1 - t1).toFixed(3);
      b.akt1.style.transform = 'translateY(' + (-40 * t1).toFixed(1) + 'px)';
      b.akt1.style.visibility = t1 >= 1 ? 'hidden' : '';
    }
    b.mons.forEach(function (el) {
      var w = we(cl(.02, .09, p));
      el.style.opacity = (1 - cl(.06, .09, p)).toFixed(3);
      el.style.transform = 'translateY(' + (-w * .22 * H).toFixed(1) + 'px)';
    });
    var tausch = cl(.095, .105, p);
    b.vor.style.opacity = (1 - tausch).toFixed(3);
    b.raum.parentNode.style.opacity = (1 - cl(.1, .24, p)).toFixed(3);

    var fr0 = b.leiste ? b.leiste.offsetHeight + (parseFloat(getComputedStyle(b.leiste).bottom) || 0) + 12 : 0;
    var seite = W >= 1024 && W / H >= 1.1;
    b.ex.classList.toggle('oe-ex--seite', seite);
    var th0 = b.kopfText && !seite ? b.kopfText.offsetHeight : 0;
    var lh = b.liste && b.liste.offsetHeight ? b.liste.offsetHeight + 12 : 0;
    function groesse(X) {
      var kH = SB.h / SB.w + (HUB[X] + 90) / 1045, spr = 0;
      var zmax = (H - fr0 - lh - th0 - (seite ? 0 : hoch ? 28 : 44) - 32 - (lh ? 0 : 2 * 56)) / kH;
      b.neun.forEach(function (t) { spr = Math.max(spr, Math.abs((t.s.u - .5) * 1045 + t[X][0]) + t.s.w * 1045 / 2 + 8); });
      return { zmax: zmax, zw: Math.max(SB.w * .5, Math.min(hoch ? .92 * W / (2 * spr / 1045) : Math.min(.64 * W / 1.5, .95 * H), zmax)) };
    }
    var thK = th0, lu0 = hoch ? 28 : 44;
    if (hoch && b.kopfText) { thK = 0; b.schritte.forEach(function (el, j) { if (j < 3 && el.firstElementChild) thK = Math.max(thK, el.firstElementChild.offsetHeight); }); }
    function umriss(X) {
      var hM = SB.h / SB.w * 1045, ga = ST['arm-r2'].w * 1045, o = 1e9, u = -1e9, r = 0, oE;
      function box(x, y, g, i) {
        r = Math.max(r, Math.abs(x + (i[0] - .5) * g), Math.abs(x + (i[2] - .5) * g));
        o = Math.min(o, y + (i[1] - .5) * g); u = Math.max(u, y + (i[3] - .5) * g);
      }
      Object.keys(IN).forEach(function (k) {
        if (k === 'fed') return;
        var x = (ST[k].u - .5) * 1045 + EXT[X][k][0], y = ST[k].v * hM + EXT[X][k][1], g = ST[k].w * 1045;
        box(x, y, g, IN[k]);
        if (k === 'arm-r2') box(x, y, ga, IN.fed);
        if (k === 'platte-r') box(x + ga * 46 / 800, y - ga * 267 / 800, g, IN[k]);
      });
      oE = o;
      box(0, -KOPF[X] - 80, ST['platte-r'].w * 1045, IN['platte-r']);
      var platz = H - fr0 - lh - lu0 - 32 - (lh ? 0 : 2 * 56);
      var zw = Math.min((W - (lh ? 28 : 80)) / (2 * r / 1045), (platz - thK) / ((u - o) / 1045), (H - fr0 - th0 - lu0 - 32) / .64);
      return { zw: Math.max(SB.w * .5, zw), zmax: zw, hub: -oE, kopf: oE - o, u: u };
    }
    var X = 'x', gr = hoch ? umriss('x') : groesse('x');
    if (hoch) { var gh = umriss('xh'); if (gh.zw > gr.zw) { X = 'xh'; gr = gh; } }
    var hub = gr.hub || HUB[X], zmax = gr.zmax, zw = gr.zw, zx = hoch ? W / 2 : W * .55, zy = H * (hoch ? .64 : .68);
    if (seite) {
      var rand = Math.max(40, (W - 1360) / 2 + 40), rechts = W - rand;
      var tr = b.kopfText ? b.kopfText.getBoundingClientRect().right - br.left : W * .36;
      zw = Math.max(SB.w * .5, Math.min(zmax, (rechts - tr - 32) / 1.32, .95 * H));
      zx = Math.min(rechts - .66 * zw, Math.max((tr + rechts) / 2, tr + 32 + .66 * zw));
    }
    var z = we(cl(.1, .28, p)), bw = le(SB.w, zw, z), bcx = le(SB.l + SB.w / 2, zx, z), bh = SB.h * bw / SB.w, bcy = le(SB.t + SB.h / 2, zy, z), mm = bw / 1045;
    var e = eo(cl(.1, .34, p)), info = we(cl(.32, .40, p)), out = we(cl(.42, .50, p)), inn = we(cl(.48, .58, p)), kp = we(cl(.62, .72, p));

    var bo = Math.max(br.top, haft), weg = bo - br.top;
    var f = 0, zk = null;
    if (b.ziel && document.body.contains(b.ziel.box)) {
      var kr = b.ziel.box.getBoundingClientRect();
      var ziel = Math.max(haft + 16, Math.min(vh * .3, vh - kr.height - 24));
      f = kl(weg / Math.max(vh * .25, kr.top + weg - ziel));
      zk = { l: kr.left + ZR[0] * kr.width, t: kr.top + ZR[1] * kr.height, w: (ZR[2] - ZR[0]) * kr.width, h: (ZR[3] - ZR[1]) * kr.height };
    }
    var rz = we(cl(.74, .94, p)), bzw = bw * 1.05, bzh = bzw * 770 / 1344, bzl = br.left + bcx - bzw / 2, bzt = bo + bcy - bzh * .62;
    var landen = cl(.9, 1, f), vs = .03, spn = 1 - vs * 11 - .08, pos = {}, bl = br.left + bcx - bw / 2, bt = bo + bcy - bh / 2, ga = ST['arm-r2'].w * bw;

    var th = b.kopfText && !seite ? b.kopfText.offsetHeight : 0, lu = seite ? 0 : hoch ? 28 : 44;
    if (hoch) th = le(thK, th, cl(.73, .79, p));
    var frei = fr0 + (hoch ? lh * (1 - cl(.74, .8, p)) : lh);
    var nameU = b.name.stange && !lh ? (b.name.stange.offsetHeight + 8) * (1 - rz) : 0;
    var oben = le(bt - (e * hub + kp * (hoch ? gr.kopf : 90)) * mm, bzt, rz) - bo;
    var unten = le(hoch ? bt + Math.max(bh, le(bh, gr.u * mm, e)) : bt + bh, bzt + bzh, rz) - bo;
    var nameO = lh ? 0 : 56 * (1 - rz);
    var gtop = Math.max(16, (H - frei - (th + lu + nameO + unten + nameU - oben)) / 2), DY = (gtop + th + lu + nameO - oben) * z;
    bt += DY; bzt += DY;
    if (b.kopfText) b.kopfText.style.top = (seite ? le(H * .06, (H - frei - b.kopfText.offsetHeight) / 2, z) : le(H * .06, gtop, z)).toFixed(1) + 'px';

    function flug(i, x, y, g, ziel) {
      if (ziel && rz > 0) { x = le(x, bzl + ziel.u * bzw, rz); y = le(y, bzt + ziel.v * bzh, rz); g = le(g, ziel.w * bzw, rz); }
      if (zk && f > 0 && ziel) {
        var fi = we(kl((f - i * vs) / spn));
        x = le(x, zk.l + ziel.u * zk.w, fi); y = le(y, zk.t + ziel.v * zk.h, fi); g = le(g, ziel.w * zk.w, fi);
      }
      return [x, y, g];
    }

    b.neun.forEach(function (t, i) {
      var x = bl + t.s.u * bw + e * t[X][0] * mm, y = bt + t.s.v * bh + e * t[X][1] * mm, g = t.s.w * bw, o = 1, sg = t.k.indexOf('-l') > 0 ? -1 : 1, x0 = x, y0 = y;
      if (t.k === 'arm-r2' || t.k === 'arm-l2') { x += sg * out * .5 * W; o = 1 - out; }
      if (t.k.indexOf('platte') === 0) { x += sg * inn * ga * 46 / 800; y -= inn * ga * 267 / 800; }
      pos[t.k] = { x: x, y: y, g: g, x0: x0, y0: y0 };
      var r = flug(i, x, y, g, geo(t.k, T1));
      setz(t.el, r[0], r[1], r[2], o);
    });
    b.feds.forEach(function (fd, j) {
      var q = pos[fd.arm];
      if (!q) return;
      var x = le(q.x0 + fd.sg * .45 * W, q.x0, inn);
      var r = flug(9 + j, x, q.y0, ga, geo(fd.k, T1));
      setz(fd.el, r[0], r[1], r[2], inn);
    });
    var st = pos['stange'], kx = st ? st.x : bl + bw / 2, ky = bt - e * KOPF[X] * mm - 80 * mm, gk = ST['platte-r'].w * bw;
    if (b.kopf) {
      var rk = flug(11, kx, le(ky - .5 * H, ky, kp), gk, T1['kopf']);
      setz(b.kopf, rk[0], rk[1], rk[2], kp);
    }

    var fade = 1 - cl(.05, .2, f), lf = fade * (1 - cl(.74, .8, p));
    ['stange', 'verbinder-r', 'arm-r1', 'platte-r'].forEach(function (k) {
      var el = b.name[k], q = pos[k];
      if (!el || !q) return;
      var dy = k === 'stange' ? q.g * .3 : (k === 'verbinder-r' ? q.g * .2 : -q.g * .3), a = info * lf;
      if (k === 'platte-r') a *= 1 - cl(.42, .46, p) + cl(.58, .62, p);
      if (k === 'arm-r1') a *= 1 - cl(.42, .46, p);
      schild(el, q.x, q.y + dy);
      el.style.opacity = kl(a).toFixed(3);
    });
    if (lh) {
      b.liste.style.bottom = fr0.toFixed(1) + 'px';
      b.liste.style.opacity = (info * lf).toFixed(3);
      var Z = { arm: 1 - .6 * cl(.42, .46, p), fed: cl(.56, .62, p), kopf: cl(.7, .76, p) };
      Object.keys(Z).forEach(function (k) { if (b.zeile[k]) b.zeile[k].style.opacity = Z[k].toFixed(3); });
    }
    var qr = pos['arm-r2'];
    if (b.name.fed && qr) {
      schild(b.name.fed, qr.x0 + ga * .3, qr.y0 - ga * .38);
      b.name.fed.style.opacity = (cl(.56, .62, p) * lf).toFixed(3);
    }
    if (b.name.kopf) {
      schild(b.name.kopf, kx, ky - gk * .25);
      b.name.kopf.style.opacity = (cl(.7, .76, p) * lf).toFixed(3);
    }

    var FE = [[.30, .42], [.45, .60], [.63, .73], [.76, 2]];
    b.schritte.forEach(function (el, j) {
      var a = FE[j] ? FE[j][0] : 2, c = FE[j] ? FE[j][1] : 3, o = cl(a, a + .03, p) * (1 - cl(c - .03, c, p));
      el.style.opacity = o.toFixed(3);
      el.style.transform = 'translateY(' + ((1 - cl(a, a + .03, p)) * 12).toFixed(1) + 'px)';
    });
    if (b.kopfText) b.kopfText.style.opacity = fade.toFixed(3);

    if (b.leiste) {
      var sh = document.querySelector('[data-oe-set-liste] .section-resource-list__header');
      var sv = sh ? sh.getBoundingClientRect().top < vh * .85 : false;
      var mo = cl(.005, .03, p) * (sv ? 0 : 1);
      b.leiste.style.opacity = mo.toFixed(3);
      b.leiste.style.visibility = mo > 0 ? 'visible' : 'hidden';
      b.leiste.style.pointerEvents = mo > .5 ? 'auto' : 'none';
      b.leiste.style.transform = 'translate(-50%,' + ((1 - mo) * 16).toFixed(1) + 'px)';
    }

    var vis = tausch * (1 - landen);
    b.ebene.style.opacity = vis.toFixed(3);
    b.ebene.style.visibility = vis > 0 ? 'visible' : 'hidden';
  }

  var geplant = false;
  function bald() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () {
      geplant = false;
      buehnen.forEach(zeichne);
    });
  }
  function neu() {
    buehnen.forEach(function (b) {
      b.SB = null;
      if (b.ruhig && b.schmalR !== ((window.innerWidth || document.documentElement.clientWidth) < 750)) ruhigBauen(b);
    });
    bald();
  }

  var ro = window.ResizeObserver ? new ResizeObserver(neu) : null;
  var lauscht = false;

  function start() {
    var vorher = buehnen.length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-oe-ex-spur]'), einrichten);
    var dazu = buehnen.slice(vorher);
    if (!dazu.length) return;
    if (!lauscht) {
      lauscht = true;
      document.addEventListener('scroll', bald, { capture: true, passive: true });
      window.addEventListener('resize', neu);
    }
    dazu.forEach(function (b) {
      if (ro) ro.observe(b.bu);
      if (!b.raum.complete) b.raum.addEventListener('load', neu, { once: true });
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(neu);
    neu();
  }

  function abbauen(b) {
    if (ro) ro.unobserve(b.bu);
    if (b.ruhig) return;
    if (b.ebene.parentNode) b.ebene.parentNode.removeChild(b.ebene);
    if (b.leiste && b.leiste.parentNode) b.leiste.parentNode.removeChild(b.leiste);
  }

  document.addEventListener('shopify:section:unload', function (e) {
    buehnen = buehnen.filter(function (b) {
      if (!e.target.contains(b.spur)) return true;
      abbauen(b);
      return false;
    });
  });
  document.addEventListener('shopify:section:load', function () {
    buehnen.forEach(function (b) {
      if (!b.ziel || !document.body.contains(b.ziel.box)) zielSuchen(b);
    });
    start();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
